import axios from '@/axios'
async function getWare() {
  var waresJSON = localStorage.getItem('wares')
  if (waresJSON != null&&waresJSON!='') {
    var wares = JSON.parse(waresJSON)
    return wares
  } else {
    var url = 'maint/MaintWare/queryByUserId.do'
    var param = {}
    let res = await axios.get(url, param)
    localStorage.setItem('wares', JSON.stringify(res.data.data))
    return res.data.data
  }
}

// function getware(){
//   var url = 'maint/MaintWare/queryByUserId.do'
//   var param = {}
//   axios.get(url, param).then(response => {
//      console.log(response.data.data)
//      return  response.data.data
//   })
// }

export default {
  getWare
};



// WEBPACK FOOTER //
// ./src/tools/common.js